export default __webpack_public_path__ + "static/media/轮播首图1.63dc6558.jpg";